import { render } from "./icon-document-view.vue?vue&type=template&id=b8950b8e"
import script from "./icon-document-view.vue?vue&type=script&lang=js"
export * from "./icon-document-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__